window.onload = () => {
	$('.toggle-title').on('click', function (e) {
      var element = $(e.target).next();
      if (event.target != this) {
        var element = $(e.target).parent().next();
      }
      if($(element).is(':visible')){
      	$(element).hide();
        $(this).find('span.plus-sign').show();
        $(this).find('span.minus-sign').hide();
      } else {
        $(element).show();
        $(this).find('span.minus-sign').show();
        $(this).find('span.plus-sign').hide();
      }
	});
};

